import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { YSButton } from "../../../uikit/YSButton";
import { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  greyColor,
  InputSMBoxStyle,
  BtnSMGroupStyle,
  LabelSMBoxStyle,
  HtmlTooltip,
  ContentStyle,
  DRxSelectStyle,
  DRxInputStyle,
} from "../../../Theme";
import { useLocation, useNavigate } from "react-router";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import { PatientInfoCard } from "../../../components/Content";
import { HelpGuideTooltip } from "../../../components/HelpGuideTooltip";
import DRxInput from "../../../uikit/DRxInput";
import useFetch from "../../../CustomHooks/useFetch";
import { RxFillDetails } from "../../../Apis/AuthApiServices";
import { DRxSelect2 } from "../../../uikit/DRxSelect2";
import { useSelector } from "react-redux";

const initialStateRxFillReview = {
  rxSSMsgNumber: null,
  rxfillId: "",
  rxId: "",
  rxNorm: "",
  rxFillStatus: "",
  sig: "",
  strength: "",
  strengthUnit: "",
  dosageForm: "",
  daysSupply: "",
  refills: "",
  pharmacyNotes: "",
  quantity: "",
  alertDescription: "",
  alertDate: "",
  messageId: "",
  refillsQualifier: "",
  writtenDate: "",
  createdDate: "",
  pharmacyNote: "",
  drugDescription: "",
  deaClassCode: "",
  dispensibleDrugId: null,
  substitution: "",
  patientDetails: null,
  dispensedDrugInfo: null,
  pharmacyDetailsList: null,
};

export default function RxFillReview() {
  const [initialData, setInitialData] = useState(initialStateRxFillReview);
  const { state }: any = useLocation();
  const history = useNavigate();
  const AllDropdwonsState = useSelector((state: any) => {
    return { ...state.GlobalDropdownSlice.DropdownLists };
  }); //redux data

  const doctorId: any = localStorage.getItem("doctorId");
  const Params = {
    doctorId: doctorId,
    messageId: state?.rowData?.messageId,
  };
  const { data, loading }: any = useFetch(Params, RxFillDetails, []);

  useEffect(() => {
    if (data[0]) {
      setInitialData(data[0]);
    }
  }, [data]);

  return (
    <>
      <ContentStyle>
        <Typography
          className="help"
          component="h6"
          color="primary"
          variant="h6"
        >
          Rx Fill{" "}
          <HelpGuideTooltip
            content={
              <>
                {" "}
                <Typography component="div" variant="body1">
                  With RxFill, a pharmacy can indicate whether the prescription
                  has been dispensed, partially dispensed, not dispensed, or
                  transferred
                </Typography>
              </>
            }
          />
        </Typography>
        {loading ? (
          <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100vh"}
          >
            <CircularProgress color="primary" />
          </Grid>
        ) : (
          <Formik
            initialValues={initialData}
            enableReinitialize={true}
            onSubmit={(values) => {
              console.log(values);
            }}
          >
            {(registerProps) => (
              <Form onSubmit={registerProps.handleSubmit}>
                <PatientInfoCard
                  name={data[0]?.patientDetails?.patientName}
                  patientId={data[0]?.patientDetails?.patientId}
                  age={data[0]?.patientDetails?.patientAge}
                  telePhone={data[0]?.patientDetails?.patientWorkPhone}
                  address={data[0]?.patientDetails?.patientAddress}
                  ssn={data[0]?.patientDetails?.patientSSN}
                  dateOfBirth={data[0]?.patientDetails?.patientDOB}
                  gender={data[0]?.patientDetails?.patientGender}
                />
                <Grid
                  container
                  item
                  xs={12}
                  spacing={0}
                  alignItems="top"
                  justifyContent="space-between"
                  columnSpacing={5}
                >
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="writtendate"
                      >
                        Written Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="writtendate"
                            name="writtenDate"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  {/* <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="lastfilleddate"
                      >
                        Last Filled Date
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="lastfilleddate"
                            name="LastFilledDate"
                            type="text"
                            className=""
                            disabled={true}
                            value={data[0]?.dispensedDrugInfo?.lastFillDate}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid> */}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="sig"
                      >
                        SIG
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="sig"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="drugdescription"
                      >
                        Drug Description
                      </Typography>{" "}
                      <Box display={{ xs: "flex", sm: "flex", md: "flex" }}>
                        <DRxInputStyle>
                          <DRxInput
                            id="drugdescription"
                            name="drugDescription"
                            type="text"
                            className=""
                            disabled={true}
                          />{" "}
                        </DRxInputStyle>
                        <HtmlTooltip
                          placement="right"
                          arrow
                          title={<DispensedDrugInfo row={initialData} />}
                        >
                          <IconButton className="tooltip">
                            <img src={InfoIcon} alt="Tooltip" loading="lazy" />
                          </IconButton>
                        </HtmlTooltip>
                      </Box>{" "}
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="DaysSupply"
                      >
                        Days Supply{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="daysSupply"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Qualifier"
                      >
                        Qualifier{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="Qualifier"
                            type="text"
                            className=""
                            disabled={true}
                            value={data[0]?.dispensedDrugInfo?.qualifier}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Quantity"
                      >
                        Quantity{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="quantity"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Quantity"
                        marginTop={"0 !important"}
                      >
                        Total number of dispensings approved{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="refills"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>{" "}
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="NoteFromPharmacy"
                        marginTop={"0 !important"}
                      >
                        Note From Pharmacy{" "}
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="pharmacyNote"
                            type="text"
                            className=""
                            disabled={true}
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="Note"
                      >
                        Note
                      </Typography>{" "}
                      <Box>
                        <DRxInputStyle>
                          <DRxInput
                            id="sig"
                            name="Note"
                            type="text"
                            className=""
                          />
                        </DRxInputStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        htmlFor="substitutionCode"
                      >
                        Substitutions
                      </Typography>
                      <Box>
                        {/* <DRxSelectStyle>
                          <DRxInput
                            name="substitutions"
                            id="substitutions"
                            disabled={true}
                            value={data[0]?.dispensedDrugInfo?.substitution}
                          />
                        </DRxSelectStyle> */}
                        <DRxSelectStyle>
                          <DRxSelect2
                            name="substitution"
                            id="substitution"
                            options={
                              AllDropdwonsState?.substitutionCodeOptions ?? [
                                { label: "", value: "" },
                              ]
                            }
                            disabled={true}
                            value={
                              data[0]?.dispensedDrugInfo?.substitution ===
                              "Substitution Allowed"
                                ? "0"
                                : data[0]?.dispensedDrugInfo?.substitution ===
                                  "Dispense As Written"
                                ? "1"
                                : "7"
                            }
                          />
                        </DRxSelectStyle>
                      </Box>
                    </InputSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LabelSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                      >
                        RxFill Type
                      </Typography>
                      <Box>
                        <DRxInput
                          id="sig"
                          name="rxFillStatus"
                          type="text"
                          className=""
                          disabled={true}
                        />
                      </Box>
                    </LabelSMBoxStyle>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <LabelSMBoxStyle>
                      <Typography
                        component="label"
                        color={greyColor}
                        variant="body2"
                        marginTop={2}
                      >
                        Pharmacy
                      </Typography>
                      <Box>
                        <Typography
                          component="div"
                          color="primary"
                          variant="body2"
                        >
                          {data[0]?.pharmacyDetailsList?.pharmacyName}
                          <HtmlTooltip
                            placement="right"
                            arrow
                            title={<PharmacyDetails row={initialData} />}
                            className="w316"
                          >
                            <IconButton className="tooltip">
                              <img
                                src={InfoIcon}
                                alt="Tooltip"
                                loading="lazy"
                              />
                            </IconButton>
                          </HtmlTooltip>
                        </Typography>
                      </Box>
                    </LabelSMBoxStyle>
                  </Grid>
                  <Grid item xs={12}>
                    <BtnSMGroupStyle>
                      <YSButton
                        className={""}
                        children={"Back"}
                        onClick={() => history("/rxfill")}
                        variant={"outlined"}
                        type={"button"}
                        size={"large"}
                        color="secondary"
                      />
                    </BtnSMGroupStyle>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </ContentStyle>
    </>
  );
}

const DispensedDrugInfo = (props: any) => {
  const { row } = props;
  const { dispensedDrugInfo } = row;
  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        Medication Dispensed
      </Typography>

      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Drug Name:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.drugName ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Qualifier:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.qualifier ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Quantity:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.quantity ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Total no.of dispensing requested:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.totalNumberOfDispensingsRequested ??
              "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Notes:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.notes ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Substitution:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.substitution ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Directions:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.directions ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Written Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.writtenDate ?? "Not Available"}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            LastFill Date:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {dispensedDrugInfo?.lastFillDate ?? "Not Available"}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

const PharmacyDetails = (props: any) => {
  const { row } = props;
  const { pharmacyDetailsList } = row;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.pharmacyName ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          24 Hours Service:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.hoursOfService ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Store:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.store ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Address:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.address ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Land Mark:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.landMark ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          City:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.city ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          State:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.state ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Zip:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.zip ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Phone:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.phone ?? "Not Available"}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Fax:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {pharmacyDetailsList?.fax ?? "Not Available"}
        </Typography>
      </Grid>
    </Grid>
  );
};
